import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'HOME' },
    { path: '/about', label: 'ABOUT' },
    { path: '/services', label: 'SERVICES' },
    { path: '/infrastructure', label: 'INFRASTRUCTURE' },
    { path: '/projects', label: 'PROJECTS' },
    { path: '/credentials', label: 'CREDENTIALS' },
    { path: '/contact', label: 'CONTACT' },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-white border-t-4 border-t-orange-500 shadow-md">
      <div className="max-w-screen-xl mx-auto px-4">
        <div className="flex justify-between items-center h-20">
    
         {/* Logo */}
<Link to="/" className="flex items-center gap-2 flex-shrink-0" data-testid="navbar-logo">
  <img
    src="/logoDurga.jpeg"
    alt="Durga Engineering Works"
    className="h-14 w-auto"
  />
  <span className="font-oswald font-bold text-xl text-slate-900 hidden lg:block whitespace-nowrap">
    DURGA <span className="text-orange-500">ENGINEERING WORKS</span>
  </span>
</Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-5 xl:gap-7">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
                className={`font-oswald text-sm tracking-wide whitespace-nowrap transition-colors ${
                  location.pathname === link.path
                    ? 'text-orange-500 font-bold'
                    : 'text-slate-700 hover:text-orange-500'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block flex-shrink-0">
            <Link
              to="/quotation"
              data-testid="request-quote-btn"
              className="bg-orange-500 hover:bg-orange-600 text-white font-bold font-oswald text-sm px-5 py-3 tracking-wider transition-all shadow-md hover:shadow-lg whitespace-nowrap"
            >
              REQUEST QUOTE
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-slate-900 p-2"
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Nav */}
        {isOpen && (
          <div className="lg:hidden border-t border-slate-200 py-4" data-testid="mobile-menu">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
                className={`block font-oswald py-3 px-4 text-base border-b border-slate-100 ${
                  location.pathname === link.path
                    ? 'text-orange-500 font-bold bg-orange-50'
                    : 'text-slate-700 hover:bg-slate-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/quotation"
              onClick={() => setIsOpen(false)}
              data-testid="mobile-request-quote-btn"
              className="block bg-orange-500 text-white font-bold font-oswald text-center py-3 mt-4 mx-4"
            >
              REQUEST QUOTE
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
